import React from "react";
import InputSearch from "../../Atomes/Inputs/InputSearch";
import Select from "../../Atomes/Select/Select";
import ButtonPopupDatepicker from "../../Atomes/Buttons/ButtonPopupDatepicker";

const FilterSearchTwoSelectsDatepicker =
	({
		 onSearch,
		 onChangeSearchValue,
		 placeHolderSearch,
		 firstDefaultValue,
		 firstOptions,
		 firstValue,
		 onFirstChange,
		 firstSelectedValue,
		 showFirstDefaultOption = true,
		 secondDefaultValue,
		 secondOptions,
		 secondValue,
		 onSecondChange,
		 secondSelectedValue,
		 showSecondDefaultOption = true,
		 date,
		 onChangeDate,
		 resetDateSelected
	 }) => {
		return (
			<div className={"filter-search-select-button"}>
				<InputSearch
					placeholder={placeHolderSearch ? placeHolderSearch : "Recherche"}
					name={"Recherche"}
					onChangeSearch={onSearch}
					onChangeSearchValue={onChangeSearchValue}
				/>
				<Select
					defaultValue={firstDefaultValue}
					styleSelect={"select-custom-secondary"}
					data={firstOptions}
					value={firstValue}
					onChange={onFirstChange}
					selectedValue={firstSelectedValue}
					showDefaultOption={showFirstDefaultOption}
				/>
				<Select
					defaultValue={secondDefaultValue}
					styleSelect={"select-custom-secondary"}
					data={secondOptions}
					value={secondValue}
					onChange={onSecondChange}
					selectedValue={secondSelectedValue}
					showDefaultOption={showSecondDefaultOption}
				/>
				<ButtonPopupDatepicker date={date} onChange={onChangeDate} resetDateSelected={resetDateSelected}/>
			</div>
		);
	};

export default FilterSearchTwoSelectsDatepicker;


